'use strict';

var React = require('react');

var SvgToolsMajor = function SvgToolsMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.52 3.83a4.768 4.768 0 0 1 6.423 5.374l2.783 2.782a2.644 2.644 0 0 1-3.74 3.74l-2.782-2.782a4.768 4.768 0 0 1-5.373-6.424.75.75 0 0 1 1.228-.256l1.646 1.647a.853.853 0 0 0 1.206-1.206l-1.646-1.646a.75.75 0 0 1 .256-1.228Zm1.809 1.17.643.644a2.353 2.353 0 1 1-3.327 3.327l-.644-.644a3.268 3.268 0 0 0 4.216 3.069.75.75 0 0 1 .748.187l3.082 3.082a1.144 1.144 0 1 0 1.618-1.618l-3.082-3.082a.75.75 0 0 1-.187-.748 3.268 3.268 0 0 0-3.067-4.217Z"
  }));
};
SvgToolsMajor.displayName = "ToolsMajor";

exports.SvgToolsMajor = SvgToolsMajor;
